/**
 * ESM view of the Ιδιότητα/τίτλος categories.
 *
 * The implementation lives in job-title.cjs so the CommonJS backend can
 * canonicalise on write with exactly the rule the forms use — two copies of a
 * matching rule is how one would drift and the counts split again.
 */
import jobTitle from './job-title.cjs';

export const JOB_TITLE_OTHER = jobTitle.JOB_TITLE_OTHER;
export const JOB_TITLE_OPTIONS = jobTitle.JOB_TITLE_OPTIONS;
export const categoryKey = jobTitle.categoryKey;
export const canonicalJobTitle = jobTitle.canonicalJobTitle;
export const jobTitleSelection = jobTitle.jobTitleSelection;
